//PScrollbar
import PerfectScrollbar from 'perfect-scrollbar';

const defaultSettings = () => ({
    className:"" ,
    lockX:false,
    lockY:false,
    option:null,
    options:null
});

export default class   PScrollbar  {

    constructor(element, userSettings = {}) {
        if (typeof element === 'string') {
            element = document.querySelector(element);
        }

        if (!element || !element.nodeName) {
            throw new Error('no element is specified to initialize DropDown');
        }

        this.element = element;

        this.settings = defaultSettings();
        for (const key in userSettings) {
            this.settings[key] = userSettings[key];
        }

        this.ps=null;
        this.isAlive = true;

        this.Hrefresh=this.refresh.bind(this);
        this.ps = new PerfectScrollbar(this.element, this.settings.options || this.settings.option);
        this.resized=new ResizeObserver(this.Hrefresh).observe(this.element);
    }


    refresh( ) {
        if (this.isAlive) {
            this.ps.update();
        }
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        if(this.resized!=null){
            this.resized.unobserve(this.element);
        }

        this.isAlive = false;
    }
}
